import { render, staticRenderFns } from "./ForecastManagement.vue?vue&type=template&id=75bb54f4&scoped=true"
import script from "./ForecastManagement.vue?vue&type=script&lang=js"
export * from "./ForecastManagement.vue?vue&type=script&lang=js"
import style0 from "./ForecastManagement.vue?vue&type=style&index=0&id=75bb54f4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bb54f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bb54f4')) {
      api.createRecord('75bb54f4', component.options)
    } else {
      api.reload('75bb54f4', component.options)
    }
    module.hot.accept("./ForecastManagement.vue?vue&type=template&id=75bb54f4&scoped=true", function () {
      api.rerender('75bb54f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/ForecastManagement.vue"
export default component.exports